import React, { useState } from "react";
import axios from "axios";
import RegisterPage from "../../components/Account/Register";
import {
  headers,
  setStorage,
  setStorageEmail,
  setStorageExp,
} from "../../libs";
import { ValNext, ValSignup } from "../../validation/UserValidation";
import { useHistory } from "react-router-dom";
import ToastError from "../../components/Notification/ToastError";

const initialData = {
  first_name: "",
  last_name: "",
  email: "",
  no_hp: 0,
  no_ktp: 0,
  password: "",
  c_password: "",
};

function Register() {
  const history = useHistory();

  const [data, setData] = useState(initialData);
  const [isError, setError] = useState([]);
  const [loading, setLoading] = useState(false);

  const [view, setView] = useState(false);
  const [isTab, setTab] = useState(1);

  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  const onView = () => {
    if (view) {
      setView(false);
    } else {
      setView(true);
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "no_ktp" || name === "no_hp") {
      setData({ ...data, [name]: value.replace(/[^0-9]/g, "") });
    } else {
      setData({ ...data, [name]: value });
    }
    setError([]);
  };

  const onSubmit = async () => {
    const error = await ValSignup(data);
    setLoading(true);

    if (error.length > 0) {
      setError(error);
      setLoading(false);
    } else {
      if (data.last_name.length === 0) {
        delete data.last_name;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/register`,
        data,
        { headers: await headers(data) }
      );

      if (Number(response.data.code) === 200) {
        await setStorage(response.data.access_token);
        await setStorageEmail(response.data.data.email);
        await setStorageExp(response.data.expires_at);
        setTimeout(() => {
          history.push("/account/verification");
          setLoading(false);
          onReset();
        }, 4500);
      } else {
        setLoading(false);
        setOpen(true);
        setResponse(response.data.message);
      }
    }
  };

  const onReset = () => {
    setView(false);
    setError([]);
    setData(initialData);
  };

  const onTab = async (value) => {
    const error = await ValNext(data);

    if (error.length > 0) {
      setError(error);
    } else setTab(value);
  };

  return (
    <>
      <ToastError props={{ open, response, onError }} />
      <RegisterPage
        props={{
          data,
          view,
          isError,
          loading,
          onView,
          onChange,
          onSubmit,
          isTab,
          onTab,
        }}
      />
    </>
  );
}

export default Register;
